import { useMenuIsFullWidth } from '@/src/app/main/menu'
import * as Surveys from '@/src/experiences/surveys'
import { Stack } from 'expo-router'
import { View } from 'react-native'
import { mesaColorNames } from '@/src/common/theme'

// eslint-disable-next-line
export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: '(tabs)',
  tabs: {
    initialRouteName: 'home',
  },
}

export default function MainLayout() {
  return (
    <Surveys.Context.SurveysProvider>
      <View
        style={{
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <LayoutNav />
      </View>
    </Surveys.Context.SurveysProvider>
  )
}

function LayoutNav() {
  const menuIsFullWidth = useMenuIsFullWidth()
  const menuBackgroundColor = menuIsFullWidth ? '#00000050' : 'transparent'

  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="(tabs)" />
      <Stack.Screen
        name="menu"
        options={{
          presentation: 'containedTransparentModal',
          animation: 'fade',
          statusBarBackgroundColor: menuBackgroundColor,
          contentStyle: { backgroundColor: menuBackgroundColor },
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="notification-center"
        options={{
          presentation: 'containedTransparentModal',
          animation: 'fade',
          statusBarBackgroundColor: menuBackgroundColor,
          contentStyle: { backgroundColor: menuBackgroundColor },
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="notification-settings"
        options={{ contentStyle: { flex: 1 }, presentation: 'transparentModal' }}
      />
      <Stack.Screen name="support" />
      <Stack.Screen
        name="pii-menu"
        options={{ contentStyle: { flex: 1 }, presentation: 'transparentModal' }}
      />
      <Stack.Screen name="card-application" />
      <Stack.Screen name="redemption" options={{ presentation: 'containedTransparentModal' }} />
      <Stack.Screen
        name="mesa-in-app-browser"
        options={{ presentation: 'containedTransparentModal' }}
      />
      <Stack.Screen name="webview" options={{ presentation: 'modal', headerShown: false }} />
      <Stack.Screen
        name="refer-a-friend/index"
        options={{ statusBarBackgroundColor: mesaColorNames['Mesa - Brand/Secondary #223843'] }}
      />
    </Stack>
  )
}
